import React, { Component } from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import I18n from '../lib/i18n'
import withTracker from '../lib/withTracker'
import withStore from '../lib/withStore'
import withHeader from '../lib/withHeader'
import Config from '../configs'
import * as Grid from '../components/Grid'
import * as StyledComponent from '../styles'
import Analytics from '../lib/analytics'
import fetchContentGroupsData from '../lib/fetchContentGroupsData'

class ProductGroups extends Component {
  handleClick = (props) => {
    const param_key =  _.keys(props.params)[0]
    const value = props.params[param_key]

    this.submitSearch(value, param_key)

    // track event
    Analytics.event({ category: 'Minicart - Products', action: 'Clicked Product Range', label: value })
  }

  submitSearch = (value, param_key = 'q') => {
    if ((value||'').length > 2) {
      this.props.history.push(`/${I18n.currentLocale()}/search?${param_key}=${encodeURIComponent(value)}`)
    }
  }

  componentDidMount() {
    // fetch for content_groups if it is not already in store
    _.isEmpty(this.props.store.content_groups) &&
    fetchContentGroupsData().then(content_group_data => {
      this.props.store.save(content_group_data)
    })

    // [ToDo] Find a better solution to fix bfcache (back-forward cache) issue
    window.scroll(0,1)
  }

  render() {
    const content_group_codes = Config.get('CONTENT_GROUPS')
    const content_group_containers = _.compact(_.map(content_group_codes||[], (content_group_code, index) => {
      const content_group = _.find(this.props.store.content_groups, { code: content_group_code }) || {}
      if (_.isEmpty(content_group)) return null
      return (
        <div key={`${content_group.code}-container-${index}`} className={`${content_group.code} group-container`}>
          <div className={`${content_group.code}-title title`}>
            { content_group.title }
          </div>
          <div className={`${content_group.code}-row row`}>
            {
              _.map(content_group.content_group_lines, (content_group_item, index) => {
                const titlized_content_group_name = _.upperFirst(_.camelCase(content_group.code))
                const GridComponent = Grid[`${titlized_content_group_name}Grid`] || Grid['CategoriesGrid']

                return <GridComponent key={`${content_group.title}-grid-${index}`} item={content_group_item} onClick={this.handleClick}/>
              })
            }
          </div>
        </div>
      )
    }))

    return <StyledComponent.PageContainer id='scroll-view'>
      <StyledComponent.ProductGroups>
        {
          content_group_containers
        }  
      </StyledComponent.ProductGroups>
    </StyledComponent.PageContainer>
  }
}

export default withTracker(withStore(withRouter(withHeader(ProductGroups))), {
  title: I18n.t('containers.product_groups.title')
})



// WEBPACK FOOTER //
// ./src/containers/ProductGroups.js